import React from "react";
import { Grid, makeStyles, FormHelperText } from "@material-ui/core";
import { useForm, Controller } from "react-hook-form";
import Controls from "../../components/controls";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiFormControl-root": {
      width: "100%",
      margin: theme.spacing(1),
    },
  },
  error: {
    marginLeft: 8,
    marginTop: 0,
    color: "#d73131",
    fontWeight: 600,
    fontSize: 13,
  },
}));

export default function TransferPicturesForm(props) {
  const { recordproducts, onTransferPictures } = props;
  const { watch, errors, control, handleSubmit } = useForm();

  const classes = useStyles();

  const transfer_to = watch("transfer_to");

  const transferTo = [
    { id: "ContactImages", title: "Before and After By Position" },
    { id: "ContactImagesOR", title: "OR Photos" },
    { id: "ContactImagesOther", title: "Before and After Others" },
  ];

  const typeBeforeAfter = [
    { id: "before", title: "Before" },
    { id: "after", title: "After" },
  ];

  const position = [
    { id: "Front", title: "Front" },
    { id: "Back", title: "Back" },
    { id: "Left", title: "Left" },
    { id: "Right", title: "Right" },
  ];

  const onSubmit = (data) => {
    if (typeof onTransferPictures === "function") {
      onTransferPictures(data);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className={classes.root}>
      <Grid
        container
        spacing={5}
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Grid item xs={6}>
          <Controller
            name="transfer_to"
            control={control}
            defaultValue=""
            render={({ onChange, value }) => (
              <Controls.Select
                label="Transfer To"
                options={transferTo}
                onChange={(value) => onChange(value)}
                value={value}
              />
            )}
            rules={{ required: "Transfer To is required" }}
          />
          <FormHelperText
            className={classes.error}
            id="transfer_to-helper-text"
          >
            {errors.transfer_to ? errors.transfer_to.message : " "}
          </FormHelperText>
        </Grid>
        <Grid item xs={6}>
          <Controller
            name="record_products"
            control={control}
            defaultValue={[]}
            render={({ onChange, value }) => (
              <Controls.MultipleSelect
                styleProp
                label="Procedures"
                options={recordproducts}
                value={value}
                onChange={(value) => onChange(value)}
              />
            )}
            rules={{
              validate: (value) => value.length > 0 || "Procedures is required",
            }}
          />
          <FormHelperText
            className={classes.error}
            id="record_products-helper-text"
          >
            {errors.record_products ? errors.record_products.message : " "}
          </FormHelperText>
        </Grid>
        {transfer_to && transfer_to !== "ContactImagesOR" ? (
          <Grid item xs={6}>
            <Controller
              name="type"
              control={control}
              defaultValue=""
              render={({ onChange, value }) => (
                <Controls.Select
                  label="Type"
                  options={typeBeforeAfter}
                  onChange={(value) => onChange(value)}
                  value={value}
                />
              )}
              rules={{ required: "Type is required" }}
            />
            <FormHelperText className={classes.error} id="type-helper-text">
              {errors.type ? errors.type.message : " "}
            </FormHelperText>
          </Grid>
        ) : (
          ""
        )}
        {transfer_to && transfer_to === "ContactImages" ? (
          <Grid item xs={6}>
            <Controller
              name="position"
              control={control}
              defaultValue=""
              render={({ onChange, value }) => (
                <Controls.Select
                  label="Position"
                  options={position}
                  onChange={(value) => onChange(value)}
                  value={value}
                />
              )}
              rules={{ required: "Position is required" }}
            />
            <FormHelperText className={classes.error} id="position-helper-text">
              {errors.position ? errors.position.message : " "}
            </FormHelperText>
          </Grid>
        ) : (
          ""
        )}
      </Grid>
      <Grid
        container
        spacing={2}
        style={{ justifyContent: "flex-end", alignItems: "center" }}
      >
        <Grid item xs={2}>
          <Controls.Button type="submit" text="Submit" />
        </Grid>
      </Grid>
    </form>
  );
}
